import { connect } from 'react-redux';
import { getInputDataToSend } from '../../../../store/form/selectors';
import { fetchProductsBySection, setInputDataToSend } from '../../../../store/form/actions';
import StableSection from './StableSection';
import { getValidation } from '../../../../store/validation/selectors';

const mapStateToProps = (state) => ({
  inputData: getInputDataToSend(state),
  validation: getValidation(state),
});

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },

  fetchProductsBySection: (
    section,
    panelGroup,
    postGroup,
    accessoryGroup,
    color,
    type,
    height,
  ) => {
    dispatch(fetchProductsBySection(
      section,
      panelGroup,
      postGroup,
      accessoryGroup,
      color,
      type,
      height,
    ));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(StableSection);
